import { queryOptions } from "@tanstack/react-query";
import { useAppSelector } from "../../../redux/hooks";
import { apiClient } from "../../../zodios/client";
import { useDates } from "../../../dates/DatesContext";
import type { Moment } from "moment";

type Params = {
  category?: string | number | null;
  product?: string | number | null;
  advertisement?: string | number | null;
  startDate?: Moment;
  endDate?: Moment;
  groupby?: "day" | "week" | "month";
};

export const useGetAnnotations = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end, group } = useDates();

  return (params: Params = {}) => {
    const { category = null, product = null, advertisement = null, startDate, endDate, groupby } = params;

    // Use provided dates or fall back to context dates
    const finalStart = startDate ?? start;
    const finalEnd = endDate ?? end;
    const finalGroupby = groupby ?? group;

    // Format dates with month-specific logic for month grouping
    // Clone moments before mutation to avoid side effects
    const ts_after =
      finalGroupby === "month" ?
        `${finalStart.clone().startOf("M").format("YYYY-MM-DD")}T00:00:00`
      : `${finalStart.format("YYYY-MM-DD")}T00:00:00`;
    const ts_before =
      finalGroupby === "month" ?
        `${finalEnd.clone().endOf("M").format("YYYY-MM-DD")}T23:59:59`
      : `${finalEnd.format("YYYY-MM-DD")}T23:59:59`;

    return queryOptions({
      queryKey: [
        {
          entity: "Annotations",
          marketPlace,
          category,
          product,
          advertisement,
          ts_after,
          ts_before,
          groupby: finalGroupby,
        },
      ],
      queryFn: async () =>
        await apiClient.getAnnotations({
          queries: {
            groupby: finalGroupby,
            ts_after,
            ts_before,
            marketplace: marketPlace,
            category,
            product,
            advertisement,
          },
        }),
    });
  };
};
